import {
  GetAllstageswithstsatus,
  MarkDocumentRead,
  RequestNextStage,
} from "../../utils/Api/api";
import "../../pages/InvestorCentrer/investorCenter.scss";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Context } from "../../contextApi/contextProvider";
import parser from "html-react-parser";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";
import { Stage } from "../../components/Question/Question";
import { getPostStatus } from "../../utils/isPostIdPresent";
import { AccessDOCOBJ } from "../../components/Navbar/Navbar";
import PpmPop from "../../utils/popMenu/PpmPop";
import { getDocumentSection } from "../../pages/PPMContent/Intro";
import { PageRoutes } from "../../utils/pageRoutes";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
const FAQ = () => {
  const [ppmPop, setppmPop] = useState(false);
  const [Open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState<string | false>(false);
  const [htmlStringFAQ, setHtmlStrFAQ] = useState([]);
  const loaction = useGeoLocation();
  const navigator = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const { userLoginData, accessDoc, setAccessDoc } = useContext(Context);

  const [currentStatus, setCurrentStatus] = useState({
    name: "",
    status: "",
    uid: "",
  });
  const token = JSON.parse(localStorage.getItem("access_token") as string);
  const fetchData = async () => {
    if (!token) return;
    try {
      const response1 = await cmsPrivateContent({
        post_id: "8064",
        lat: loaction.coordinates.lat,
        log: loaction.coordinates.lng,
      });

      setHtmlStrFAQ(response1);
    } catch (error) {
      console.error("Error fetching data from endpoint1:", error);
    }
  };

  const getDocumentStatusByPostId = (
    stages: Stage[],
    stage_name: string
  ): string | undefined => {
    return stages
      .find((stage) => stage.stage_name.trim() === stage_name)
      ?.stage_status.trim();
  };
  useEffect(() => {
    if (userLoginData.status == 200) {
      readDoc();
      if (accessDoc?.all_stage_info) {
        const financialProjectionStage = getDocumentStatusByPostId(
          accessDoc?.all_stage_info,
          "Stage 1 - Business Insight"
        );
        if (financialProjectionStage) {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
          fetchData();
        } else {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
          fetchData();
        }
      }
    }
    if (userLoginData.status == 404) {
      navigator(PageRoutes.home);
    }

    if (token === "" || token === null || token === undefined) {
      navigator(PageRoutes.home);
    }
    window.scrollTo(0, 0);

    document.title = "TICCA | FAQ";
  }, [userLoginData.status, accessDoc]);
  const getTalk = async () => {
    try {
      const response = await GetAllstageswithstsatus({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
      });

      if (response?.data) {
        const financialProjectionStage = await getDocumentStatusByPostId(
          response?.data?.all_stage_info,
          "Stage 1 - Business Insight"
        );

        setAccessDoc(response?.data);
        const updatedAccessDOCOBJ: AccessDOCOBJ = { ...accessDoc };
        Object.keys(updatedAccessDOCOBJ).forEach((key) => {
          const status = getPostStatus(key, response?.data?.all_stage_info);
          updatedAccessDOCOBJ[key] = status;
        });
        setAccessDoc({
          ...updatedAccessDOCOBJ,
          all_stage_info: response?.data?.all_stage_info,
        });

        if (financialProjectionStage) {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
        } else {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
        }
      }
    } catch (error) {}
  };
  const nextStage = async () => {
    setCurrentStatus({
      name: "",
      status: "",
      uid: "",
    });
    try {
      const { data } = await RequestNextStage({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
        section_id: await getDocumentSection(
          accessDoc?.all_stage_info,
          "Stage 1 - Business Insight"
        ),
      });

      if (data.status == 200) {
        getTalk();
        setppmPop(true);
      } else {
        setCurrentStatus(data);
      }
      setBtnLoading(false);
    } catch (error) {}
  };
  const handleSubmit = async () => {
    if (btnLoading) return;
    if (currentStatus.status === "ALLOWED") {
      navigator(PageRoutes.ExecutiveSummary);
    }
    if (currentStatus.status === "") {
      setBtnLoading(true);
      nextStage();
    }
  };

  const handleChangeAccodion =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const readDoc = async () => {
    if (!token) return;
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "8064",
      });
    } catch (error) {}
  };

  return (
    <>
      {" "}
      {htmlStringFAQ.length < 2 ? (
        <div className="responsive-table-container">
          <ShimmerLoaderwhite maxWidth="40vw" />{" "}
        </div>
      ) : (
        <>
          {ppmPop && <PpmPop setppmPop={setppmPop} />}
          <div id="faq" className="contact-faqs-main-dev">
            <p className="contact-faqs-title">FAQs</p>
            <div className="contect-faqs-accordionSummary-main-dev">
              <Button
                onClick={() => setOpen(!Open)}
                style={{ margin: "0px 0px 20px auto", maxWidth: "1024px" }}
                variant="outlined"
              >
                {!Open ? "Open all" : "Close all"}
              </Button>
            </div>
            <div className="contect-faqs-accordionSummary-main-dev">
              <Accordion
                expanded={expanded === "panel1" || Open}
                onChange={handleChangeAccodion("panel1")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel1"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,

                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[0] && <>{parser(htmlStringFAQ[0])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[1] && <>{parser(htmlStringFAQ[1])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2" || Open}
                onChange={handleChangeAccodion("panel2")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel2"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[2] && <>{parser(htmlStringFAQ[2])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[3] && <>{parser(htmlStringFAQ[3])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel3" || Open}
                onChange={handleChangeAccodion("panel3")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel3"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[4] && <>{parser(htmlStringFAQ[4])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[5] && <>{parser(htmlStringFAQ[5])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel4" || Open}
                onChange={handleChangeAccodion("panel4")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel4"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[6] && <>{parser(htmlStringFAQ[6])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[7] && <>{parser(htmlStringFAQ[7])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel5" || Open}
                onChange={handleChangeAccodion("panel5")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel5"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[8] && <>{parser(htmlStringFAQ[8])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[9] && <>{parser(htmlStringFAQ[9])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel6" || Open}
                onChange={handleChangeAccodion("panel6")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel6"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[10] && <>{parser(htmlStringFAQ[10])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[11] && <>{parser(htmlStringFAQ[11])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel7" || Open}
                onChange={handleChangeAccodion("panel7")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel7"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[12] && <>{parser(htmlStringFAQ[12])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[13] && <>{parser(htmlStringFAQ[13])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel8" || Open}
                onChange={handleChangeAccodion("panel8")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel8"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[14] && <>{parser(htmlStringFAQ[14])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[15] && <>{parser(htmlStringFAQ[15])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel9" || Open}
                onChange={handleChangeAccodion("panel9")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel8"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[16] && <>{parser(htmlStringFAQ[16])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[17] && <>{parser(htmlStringFAQ[17])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel10" || Open}
                onChange={handleChangeAccodion("panel10")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel10"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[18] && <>{parser(htmlStringFAQ[18])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[19] && <>{parser(htmlStringFAQ[19])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel11" || Open}
                onChange={handleChangeAccodion("panel11")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel11"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[20] && <>{parser(htmlStringFAQ[20])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[21] && <>{parser(htmlStringFAQ[21])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel12" || Open}
                onChange={handleChangeAccodion("panel12")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel12"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[22] && <>{parser(htmlStringFAQ[22])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[23] && <>{parser(htmlStringFAQ[23])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel13" || Open}
                onChange={handleChangeAccodion("panel13")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel13"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[24] && <>{parser(htmlStringFAQ[24])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[25] && <>{parser(htmlStringFAQ[25])}</>}
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel14" || Open}
                onChange={handleChangeAccodion("panel14")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel14"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[26] && <>{parser(htmlStringFAQ[26])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[27] && <>{parser(htmlStringFAQ[27])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel15" || Open}
                onChange={handleChangeAccodion("panel15")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel15"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[28] && <>{parser(htmlStringFAQ[28])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[29] && <>{parser(htmlStringFAQ[29])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel16" || Open}
                onChange={handleChangeAccodion("panel16")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel16"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[30] && <>{parser(htmlStringFAQ[30])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[31] && <>{parser(htmlStringFAQ[31])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel17" || Open}
                onChange={handleChangeAccodion("panel17")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel17"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[32] && <>{parser(htmlStringFAQ[32])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[33] && <>{parser(htmlStringFAQ[33])}</>}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel18" || Open}
                onChange={handleChangeAccodion("panel18")}
                style={{
                  boxShadow: "none",
                  backgroundColor: "rgba(183, 210, 255, 1)",
                }}
              >
                <AccordionSummary
                  style={{
                    backgroundColor: `${
                      expanded === "panel18"
                        ? " rgba(183, 210, 255, 1)"
                        : "rgba(183, 210, 255, 1)"
                    }`,
                    boxShadow: "none",
                    borderRadius: "9px",
                  }}
                  expandIcon={
                    <img
                      src={
                        "https://public.ticca.com/images/svg/ContactUsArrow.svg"
                      }
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  {htmlStringFAQ[34] && <>{parser(htmlStringFAQ[34])}</>}
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: "rgba(183, 210, 255, 1)",
                    boxShadow: "none",
                    borderTop: "1px solid rgba(130, 177, 255, 1)",
                  }}
                >
                  {htmlStringFAQ[35] && <>{parser(htmlStringFAQ[35])}</>}
                </AccordionDetails>
              </Accordion>
            </div>

            <div className="w-full flex justify-center py-10">
              <div className="flex flex-col sm:flex-row items-center gap-8">
                {/* Back Button */}
                <div className="relative group">
                  <button
                    disabled={btnLoading}
                    onClick={() => {
                      navigator(PageRoutes.InvestorCenter);
                    }}
                    className="
              flex items-center gap-2 px-8 py-3 rounded-2xl
              bg-white text-gray-700 font-semibold shadow-md
              border border-gray-200
              hover:shadow-lg hover:bg-gray-50
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
                  >
                    {btnLoading ? (
                      <Loader2 className="animate-spin w-5 h-5" />
                    ) : (
                      <>
                        <ArrowLeft size={18} />
                        Back
                      </>
                    )}
                  </button>

                  {/* Tooltip */}
                  <div
                    className="
              absolute left-1/2 -translate-x-1/2 -top-12
              bg-black text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
                  >
                    Investor landing
                  </div>
                </div>

                {/* Next Button */}
                <div className="relative group">
                  <button
                    disabled={btnLoading}
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="
              flex items-center gap-2 px-10 py-3 rounded-2xl
              bg-gradient-to-r from-blue-600 to-cyan-400
              text-white font-semibold shadow-md
              hover:shadow-xl hover:scale-[1.02]
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
                  >
                    {btnLoading ? (
                      <Loader2 className="animate-spin w-5 h-5" />
                    ) : (
                      <>
                        {accessDoc["13678"] === "PENDING"
                          ? "Your request is pending"
                          : accessDoc["13678"] === "DENIED"
                          ? "Your request is denied"
                          : accessDoc["13678"] === "ALLOWED"
                          ? "Bussiness Summary"
                          : "Learn More About TICCA"}
                        <ArrowRight size={18} />
                      </>
                    )}
                  </button>

                  {/* Tooltip */}
                  <div
                    className="
              absolute left-1/2 -translate-x-1/2 -top-12
              bg-black text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
                  >
                    Bussiness Summary
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default FAQ;
